/** Frases de boas-vindas na home do usuário — edite ou adicione itens aqui. */
export const USER_HOME_GREETING_MESSAGES = [
	'Que bom ter você aqui — cuide da sua saúde no seu ritmo.',
	'Vamos cuidar de você hoje?',
	'Tudo o que você precisa, em um só lugar.',
	'Cuidar de você começa por aqui.',
	'Seu bem-estar em primeiro lugar.',
	'Aqui é mais fácil cuidar da sua saúde.',
	'Pronto pra cuidar de você hoje.',
	'Sua saúde merece atenção todos os dias.',
	'Sua próxima sessão está esperando por você.',
	'Um espaço só seu para cuidar da saúde.',
] as const;

export const pickRandomUserHomeGreetingMessage = (): string => {
	const index = Math.floor(
		Math.random() * USER_HOME_GREETING_MESSAGES.length,
	);
	return USER_HOME_GREETING_MESSAGES[index] ?? USER_HOME_GREETING_MESSAGES[0];
};
